import { OrganizationTab } from '../Modules/Organizations/Interfaces/organization-tab.interface';
import { SystemRole } from '../Enums/system-role.enum';

export const ORGANIZATION_TABS: readonly OrganizationTab[] = [
  { id: 'overview', label: 'backoffice.organizations.tabs.overview', icon: 'info' },
  { id: 'edit', label: 'backoffice.organizations.tabs.edit', icon: 'edit' },
  { id: 'notes', label: 'backoffice.organizations.tabs.notes', icon: 'sticky_note_2' },
  {
    id: 'subscription',
    label: 'backoffice.organizations.tabs.subscription',
    icon: 'receipt_long',
  },
  {
    id: 'licences',
    label: 'backoffice.organizations.tabs.licences',
    icon: 'confirmation_number',
  },
  { id: 'devices', label: 'backoffice.organizations.tabs.devices', icon: 'devices' },
  { id: 'invoices', label: 'backoffice.organizations.tabs.invoices', icon: 'description' },
  { id: 'payments', label: 'backoffice.organizations.tabs.payments', icon: 'payments' },
];

export const ORGANIZATION_DEFAULT_TAB = 'overview';

export const ORGANIZATION_TAB_QUERY_PARAM = 'tab';

// Roles behind each write

export const ROLE_EDIT_ORGANIZATION = SystemRole.BACKOFFICE_AGENT;

export const ROLE_LIFECYCLE = SystemRole.BACKOFFICE_ADMIN;

export const ROLE_NOTES = SystemRole.BACKOFFICE_AGENT;

export const ROLE_BILLING = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const BILLING_EMAIL_SOURCE_LABEL: Readonly<Record<string, string>> = {
  billing_email: 'backoffice.organizations.overview.billing_email.source.billing_email',
  contact_email: 'backoffice.organizations.overview.billing_email.source.contact_email',
  none: 'backoffice.organizations.overview.billing_email.source.none',
};

export const NOTE_BODY_MAX = 5000;
